import React from 'react';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import SchoolIcon from '@mui/icons-material/School';
import Euro from '@mui/icons-material/Euro';
import QuizIcon from '@mui/icons-material/Quiz';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import LockResetIcon from '@mui/icons-material/LockReset';
import ShieldIcon from '@mui/icons-material/Shield';
import MonitorWeightIcon from '@mui/icons-material/MonitorWeight';
import CallMergeIcon from '@mui/icons-material/CallMerge';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import BadgeIcon from '@mui/icons-material/Badge';
import LinkIcon from '@mui/icons-material/Link';
import LabelIcon from '@mui/icons-material/Label';
import EditNoteIcon from '@mui/icons-material/EditNote';
import AssignmentIcon from '@mui/icons-material/Assignment';
import MailIcon from '@mui/icons-material/Mail';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import HomeIcon from '@mui/icons-material/Home';
import PublicIcon from '@mui/icons-material/Public';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import PersonIcon from '@mui/icons-material/Person';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import TranslateIcon from '@mui/icons-material/Translate';
import WcIcon from '@mui/icons-material/Wc';
import FavoriteIcon from '@mui/icons-material/Favorite';
import CakeIcon from '@mui/icons-material/Cake';
import NumbersIcon from '@mui/icons-material/Numbers';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import BloodtypeIcon from '@mui/icons-material/Bloodtype';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import EventNoteIcon from '@mui/icons-material/EventNote';
import HistoryIcon from '@mui/icons-material/History';
import CoPresentIcon from '@mui/icons-material/CoPresent';
import BarChartIcon from '@mui/icons-material/BarChart';
import ViewListIcon from '@mui/icons-material/ViewList';
import RepeatIcon from '@mui/icons-material/Repeat';
import BackupTableIcon from '@mui/icons-material/BackupTable';
import TodayIcon from '@mui/icons-material/Today';
import VaccinesIcon from '@mui/icons-material/Vaccines';
import MedicationIcon from '@mui/icons-material/Medication';
import EscalatorWarningIcon from '@mui/icons-material/EscalatorWarning';
import ImageSearchIcon from '@mui/icons-material/ImageSearch';
import FolderIcon from '@mui/icons-material/Folder';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import CalculateIcon from '@mui/icons-material/Calculate';
import NotesIcon from '@mui/icons-material/Notes';
import InsertCommentIcon from '@mui/icons-material/InsertComment';
import FlagIcon from '@mui/icons-material/Flag';
import HandshakeIcon from '@mui/icons-material/Handshake';
import ScheduleIcon from '@mui/icons-material/Schedule';

import InsightsIcon from '@mui/icons-material/Insights';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import FeedbackIcon from '@mui/icons-material/Feedback';
import TextsmsIcon from '@mui/icons-material/Textsms';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import SendIcon from '@mui/icons-material/Send';
import MarkEmailUnreadIcon from '@mui/icons-material/MarkEmailUnread';
import OutboxIcon from '@mui/icons-material/Outbox';
import LocalPostOfficeIcon from '@mui/icons-material/LocalPostOffice';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import CommentIcon from '@mui/icons-material/Comment';
import BedtimeIcon from '@mui/icons-material/Bedtime';
import LoginIcon from '@mui/icons-material/Login';

import HelpersPractice from './practice';
import { AdminPanelSettings } from '@mui/icons-material';

// Branded vinkje avatar used for the FileMaker link in the picture_and_tags
// widget. Wrapped here so the settings popup + status row render the exact same
// mark the runtime widget uses (an MUI icon would look foreign next to it).
// It's an <img>, so unlike MUI svg-icons it can't be tinted by state colour.
// Instead the caller passes an explicit `active` bool (the real on/off status,
// not inferred from colour — the theme can override palette colours so a hex
// compare would be fragile) and we dim it via opacity 0.3 when hidden.
// FM has no module-disabled state, so shown/hidden is the only distinction.
const FmLinkIcon = (props) => {
  const active = props?.active !== false; // default visible when unspecified
  return <img
    alt="FileMaker"
    src="https://cdn.kangacoders.com/direct/nutrilink_eu/images/vinkje_blauw_groen.png"
    style={{
      width: 16,
      height: 16,
      marginTop: -4,
      objectFit: 'contain',
      verticalAlign: 'middle',
      opacity: active ? 1 : 0.3,
    }}
  />;
};

// Centralised data + pure logic for the coach "client widgets" settings,
// currently only the goto_links widget. Kept here (not in a feature folder)
// because it's consumed by both the settings editor (pages/coach/settings)
// and the runtime widget (pages/coach/users/widgets).

export default class ClientWidgets {

  // Single source of truth for the goto_links widget: the links it can render,
  // the practice modules that gate each, and the sidebar icon shown for each.
  //
  // `moduleChecks` mirrors the practice_modules_v3 call(s) used in the widget:
  // a link is module-active if ANY of its checks passes (the diary link covers
  // eat OR move). An empty array means no module gating (always available).
  // `Icon` is the same icon the sidebar uses for that module, so the status row
  // and any future UI stay visually consistent with the navigation.
  static gotoLinksItems = [
    { key: 'appointments',   moduleChecks: ['nutri_appointment'],                  Icon: CalendarMonthIcon },
    { key: 'diary',          moduleChecks: ['nutri_diary_eat', 'nutri_diary_move'], Icon: MenuBookIcon },
    { key: 'courses',        moduleChecks: [],                                       Icon: SchoolIcon },
    { key: 'mollie_links',   moduleChecks: ['payments'],                             Icon: Euro },
    { key: 'questionnaires', moduleChecks: ['questionnaire'],                        Icon: QuizIcon },
  ];

  // Canonical default order, matching the widget's historical hardcoded order.
  // Used when no persisted goto_links_order setting exists yet.
  static defaultGotoLinksOrder = [
    'appointments',
    'diary',
    'courses',
    'mollie_links',
    'questionnaires',
  ];

  static gotoLinksValueKey = 'goto_links';
  static gotoLinksOrderKey = 'goto_links_order';

  // Per-link visibility state.
  // - 'active'   : module active and shown (primary)
  // - 'inactive' : module active but hidden by the coach (secondary)
  // - 'disabled' : module not active, can't be shown (grey)
  static getGotoLinkState = (item, visibility, currentPractice) => {
    const moduleActive = item.moduleChecks.length === 0
      ? true
      : item.moduleChecks.some((check) => !!HelpersPractice.practice_modules_v3({practice: currentPractice, check}));
    if (!moduleActive) return 'disabled';
    // default visible unless explicitly hidden
    return visibility?.[item.key] !== false ? 'active' : 'inactive';
  };

  // Resolves the render order for the goto_links widget.
  // Falls back to defaultGotoLinksOrder when no order is persisted, and
  // tolerates drift (unknown keys ignored; missing keys appended at the end)
  // so the widget never breaks on stale/partial data.
  // Each returned item carries its resolved `state`; callers filter to 'active'
  // before rendering.
  static getOrderedGotoLinks = (order, visibility, currentPractice) => {
    const fallbackOrder = ClientWidgets.defaultGotoLinksOrder;
    const resolvedOrder = (order && order.length > 0) ? order : fallbackOrder;

    const seen = new Set();
    const ordered = [];

    resolvedOrder.forEach((key) => {
      if (seen.has(key)) return;
      const item = ClientWidgets.gotoLinksItems.find((i) => i.key === key);
      if (!item) return; // ignore unknown keys
      seen.add(key);
      ordered.push(item);
    });

    // append any items missing from the resolved order (keeps new links visible
    // if a new module is added later but the coach hasn't re-saved their order)
    ClientWidgets.gotoLinksItems.forEach((item) => {
      if (seen.has(item.key)) return;
      ordered.push(item);
    });

    return ordered.map((item) => ({
      ...item,
      state: ClientWidgets.getGotoLinkState(item, visibility, currentPractice),
    }));
  };

  // ---------------------------------------------------------------------------
  // Actions widget
  // ---------------------------------------------------------------------------

  // The coach "actions" widget: a configurable list of per-client actions
  // (read eID, new episode, password reset, disable 2FA, weight trigger, merge
  // request, unlink/relink). Unlike goto_links these are NOT module-gated; each
  // action's availability depends on the viewed client's runtime state, which
  // is evaluated in the widget (not here). The helper only owns the canonical
  // item list (key + icon), the default order, and the show/hide state logic.
  //
  // Per-action render config (gate, button styling, labels, onClick) lives in
  // the widget's ACTION_RENDER map — same split as goto_links' LINK_RENDER.
  // Exclusive pairs (enable/disable weight trigger, unlink/relink, pass-reset
  // request/link-shown) are collapsed into one item each whose render picks the
  // right half based on the client's state.
  static actionsItems = [
    { key: 'read_card',        Icon: CreditCardIcon },
    { key: 'increase_episode', Icon: AddCircleIcon },
    { key: 'pass_reset',       Icon: LockResetIcon },
    { key: 'disable_mfa',      Icon: ShieldIcon },
    { key: 'weight_trigger',   Icon: MonitorWeightIcon },
    { key: 'goto_merge',       Icon: CallMergeIcon },
    { key: 'unlink',           Icon: LinkOffIcon },
    // edit_user: same affordance as the relocated CTA in the details_contact
    // widget, mirrored here so coaches can surface it from the actions column
    // too. Independent toggle — both placements can be on/off.
    { key: 'edit_user',       Icon: EditIcon },
    { key: 'gdpr_json',       Icon: AdminPanelSettings },
  ];

  // Canonical default order, matching the widget's historical top-to-bottom order.
  // `edit_user` is appended last by default (a secondary affordance).
  static defaultActionsOrder = [
    'read_card',
    'increase_episode',
    'pass_reset',
    'disable_mfa',
    'weight_trigger',
    'goto_merge',
    'unlink',
    'edit_user',
  ];

  static actionsValueKey = 'actions';
  static actionsOrderKey = 'actions_order';

  // i18n key for the note in the settings popup explaining that "hidden" actions
  // don't disappear — they move behind a "show all actions" button at runtime.
  // Hidden actions stay reachable (e.g. password reset is often only accessible
  // here, so it must never be fully removed, just tucked away).
  static actionsNoteKey = 'coach.personal_settings.userdetail_widgets.settings.actions.note';

  // Per-action visibility state. No 'disabled' state here (actions aren't
  // module-gated): the switch is a pure coach show/hide preference.
  // - 'shown'  : coach wants it directly visible (primary group)
  // - 'hidden' : coach tucked it behind "show all actions" (overflow group)
  static getActionState = (item, visibility) => {
    return visibility?.[item.key] === false ? 'hidden' : 'shown';
  };

  // Resolves the render order for the actions widget, falling back to
  // defaultActionsOrder and tolerating drift (unknown keys ignored; missing
  // keys appended). Each returned item carries its resolved `state`; the widget
  // filters by its own runtime gate and splits shown/hidden into primary/overflow.
  static getOrderedActions = (order, visibility) => {
    const fallbackOrder = ClientWidgets.defaultActionsOrder;
    const resolvedOrder = (order && order.length > 0) ? order : fallbackOrder;

    const seen = new Set();
    const ordered = [];

    resolvedOrder.forEach((key) => {
      if (seen.has(key)) return;
      const item = ClientWidgets.actionsItems.find((i) => i.key === key);
      if (!item) return; // ignore unknown keys
      seen.add(key);
      ordered.push(item);
    });

    // append any items missing from the resolved order (keeps new actions
    // visible if one is added later but the coach hasn't re-saved their order)
    ClientWidgets.actionsItems.forEach((item) => {
      if (seen.has(item.key)) return;
      ordered.push(item);
    });

    return ordered.map((item) => ({
      ...item,
      state: ClientWidgets.getActionState(item, visibility),
    }));
  };

  // ---------------------------------------------------------------------------
  // ---------------------------------------------------------------------------
  // picture_and_tags widget
  // ---------------------------------------------------------------------------
  //
  // A two-level settings widget: the whole widget has 5 top-level sections
  // (avatar, name, icon-link cluster, tags, consult reason) each with on/off
  // + order, and
  // the icon-link cluster has its own configurable sub-list with on/off + order
  // (the goto_links pattern, because some links are module-gated).
  //
  // The widget itself is NOT module-gated, but several icon links are
  // (nutri_mail / ehealth / zorgmail). Those use the 'disabled' state when their
  // module is off, exactly like goto_links. The remaining icon links
  // (fm / logs / eid) have no module gate; their client-type/runtime gates are
  // evaluated in the widget (not here).
  //
  // Because the settings dialog writes exactly one value key + one order key
  // per widget, the two visibility maps are bundled into a single composite
  // value under `picture_and_tags`:
  //   { sections: Record<string,boolean>, sections_order: string[], icon_links: Record<string,boolean> }
  // and the icon-link order lives under `picture_and_tags_order`. This needs no
  // changes to the generic dialog plumbing (buildWidgetsPayload already merges
  // settingsOverride + the order draft as siblings under `settings`).

  // The 5 top-level sections, in their default render order. `Icon` is shown in
  // the settings popup + status row. No `moduleChecks`: these are pure
  // coach show/hide preferences (no 'disabled' state).
  static pictureAndTagsSections = [
    { key: 'picture',        Icon: AccountCircleIcon },
    { key: 'name',           Icon: BadgeIcon },
    { key: 'icon_links',     Icon: LinkIcon },
    { key: 'tags',           Icon: LabelIcon },
    { key: 'consult_reason', Icon: EditNoteIcon },
  ];

  static defaultPictureAndTagsSectionsOrder = [
    'picture',
    'name',
    'icon_links',
    'tags',
    'consult_reason',
  ];

  // The icon-link sub-items shown inside the `icon_links` section.
  // `moduleChecks` mirrors the runtime module checks in PictureAndTags.tsx:
  // empty array = no module gating (always available, runtime gates only);
  // non-empty = disabled (grey, switch off) when none of the checks pass.
  static pictureAndTagsIconLinksItems = [
    { key: 'fm',        moduleChecks: [],                  Icon: FmLinkIcon },
    { key: 'logs',      moduleChecks: [],                  Icon: AssignmentIcon },
    { key: 'nutri_mail', moduleChecks: ['nutri_mail'],     Icon: MailIcon },
    { key: 'ehealth',   moduleChecks: ['ehealth'],         Icon: ContactMailIcon },
    { key: 'zorgmail',  moduleChecks: ['zorg_mail'],       Icon: ContactMailIcon },
    { key: 'eid',       moduleChecks: [],                  Icon: CreditCardIcon },
  ];

  // Canonical default order for the icon links, matching the widget's
  // historical hardcoded order (FM, logs, NutriMail, EhealthMail, ZorgMail, eID).
  static defaultPictureAndTagsIconLinksOrder = [
    'fm',
    'logs',
    'nutri_mail',
    'ehealth',
    'zorgmail',
    'eid',
  ];

  static pictureAndTagsValueKey = 'picture_and_tags';
  static pictureAndTagsOrderKey = 'picture_and_tags_order';

  // Per-section visibility state. Pure show/hide, no 'disabled' (sections are
  // not module-gated). Matches the actions widget's two-state model.
  // - 'shown'  : coach wants it visible
  // - 'hidden' : coach turned it off (section simply not rendered)
  static getPictureAndTagsSectionState = (item, visibility) => {
    return visibility?.[item.key] === false ? 'hidden' : 'shown';
  };

  static getOrderedPictureAndTagsSections = (order, visibility) => {
    const fallbackOrder = ClientWidgets.defaultPictureAndTagsSectionsOrder;
    const resolvedOrder = (order && order.length > 0) ? order : fallbackOrder;

    const seen = new Set();
    const ordered = [];

    resolvedOrder.forEach((key) => {
      if (seen.has(key)) return;
      const item = ClientWidgets.pictureAndTagsSections.find((i) => i.key === key);
      if (!item) return; // ignore unknown keys
      seen.add(key);
      ordered.push(item);
    });

    ClientWidgets.pictureAndTagsSections.forEach((item) => {
      if (seen.has(item.key)) return;
      ordered.push(item);
    });

    return ordered.map((item) => ({
      ...item,
      state: ClientWidgets.getPictureAndTagsSectionState(item, visibility),
    }));
  };

  // Per-icon-link visibility state. Mirrors goto_links' three-state model:
  // - 'active'   : module active and shown (primary)
  // - 'inactive' : module active but hidden by the coach (secondary)
  // - 'disabled' : module not active, can't be shown (grey)
  static getPictureAndTagsIconLinkState = (item, visibility, currentPractice) => {
    const moduleActive = item.moduleChecks.length === 0
      ? true
      : item.moduleChecks.some((check) => !!HelpersPractice.practice_modules_v3({practice: currentPractice, check}));
    if (!moduleActive) return 'disabled';
    // default visible unless explicitly hidden
    return visibility?.[item.key] !== false ? 'active' : 'inactive';
  };

  // Resolves the render order for the icon-link sub-list, falling back to the
  // default order and tolerating drift (unknown keys ignored; missing keys
  // appended). Each returned item carries its resolved `state`.
  static getOrderedPictureAndTagsIconLinks = (order, visibility, currentPractice) => {
    const fallbackOrder = ClientWidgets.defaultPictureAndTagsIconLinksOrder;
    const resolvedOrder = (order && order.length > 0) ? order : fallbackOrder;

    const seen = new Set();
    const ordered = [];

    resolvedOrder.forEach((key) => {
      if (seen.has(key)) return;
      const item = ClientWidgets.pictureAndTagsIconLinksItems.find((i) => i.key === key);
      if (!item) return; // ignore unknown keys
      seen.add(key);
      ordered.push(item);
    });

    // append any items missing from the resolved order (keeps new links visible
    // if one is added later but the coach hasn't re-saved their order)
    ClientWidgets.pictureAndTagsIconLinksItems.forEach((item) => {
      if (seen.has(item.key)) return;
      ordered.push(item);
    });

    return ordered.map((item) => ({
      ...item,
      state: ClientWidgets.getPictureAndTagsIconLinkState(item, visibility, currentPractice),
    }));
  };

  // Shared widget -> orderKey / defaultOrder lookups (used by the settings
  // editor to seed the order draft + render the status row for any widget that
  // has an order setting). Add a branch here when a widget gains an order setting.
  // ---------------------------------------------------------------------------

  static getOrderKeyForWidget = (widgetKey) => {
    if (widgetKey === ClientWidgets.gotoLinksValueKey) return ClientWidgets.gotoLinksOrderKey;
    if (widgetKey === ClientWidgets.actionsValueKey) return ClientWidgets.actionsOrderKey;
    if (widgetKey === ClientWidgets.pictureAndTagsValueKey) return ClientWidgets.pictureAndTagsOrderKey;
    if (widgetKey === ClientWidgets.consentsValueKey) return ClientWidgets.consentsOrderKey;
    if (widgetKey === ClientWidgets.filesSmallValueKey) return ClientWidgets.filesSmallOrderKey;
    if (widgetKey === ClientWidgets.diarySmallValueKey) return ClientWidgets.diarySmallOrderKey;
    if (widgetKey === ClientWidgets.basicAdviceValueKey) return ClientWidgets.basicAdviceOrderKey;
    // details_contact, details_basic, details_extra all have fixed field
    // orders (no persisted order setting).
    return null;
  };

  static getDefaultOrderForWidget = (widgetKey) => {
    if (widgetKey === ClientWidgets.gotoLinksValueKey) return ClientWidgets.defaultGotoLinksOrder;
    if (widgetKey === ClientWidgets.actionsValueKey) return ClientWidgets.defaultActionsOrder;
    if (widgetKey === ClientWidgets.pictureAndTagsValueKey) return ClientWidgets.defaultPictureAndTagsIconLinksOrder;
    if (widgetKey === ClientWidgets.consentsValueKey) return ClientWidgets.defaultConsentsOrder;
    if (widgetKey === ClientWidgets.filesSmallValueKey) return ClientWidgets.defaultFilesSmallOrder;
    if (widgetKey === ClientWidgets.diarySmallValueKey) return ClientWidgets.defaultDiarySmallOrder;
    if (widgetKey === ClientWidgets.basicAdviceValueKey) return ClientWidgets.defaultBasicAdviceOrder;
    return [];
  };

  // ---------------------------------------------------------------------------
  // details_contact widget
  // ---------------------------------------------------------------------------
  //
  // A contact data block (email, two phones, address, country) plus a
  // coach-level "hide empty fields" toggle and a relocated "edit contact" CTA
  // (the edit affordance used to be an icon-button top-right of the contact
  // widget; it now renders as a bottom text-button inside the widget). The edit
  // CTA is also added to the actions widget as an `edit_user` item — both
  // placements are independently toggleable.
  //
  // Settings are a composite value bundled under one key:
  //   { fields: Record<string,boolean>, hide_empty: boolean, edit: boolean }
  // No order setting — the 5 fields render in a fixed natural order (reordering
  // contact fields adds no value). If that's ever requested, add an order key
  // + a branch in getOrderKeyForWidget/getDefaultOrderForWidget.

  // The 5 contact fields, in their fixed render order. `Icon` is shown in the
  // settings popup + status row. No `moduleChecks`: pure coach show/hide
  // (two-state model, like actions — no 'disabled').
  static detailsContactItems = [
    { key: 'email',        Icon: EmailIcon },
    { key: 'phone_fixed',  Icon: PhoneIcon },
    { key: 'phone_mobile', Icon: SmartphoneIcon },
    { key: 'address',      Icon: HomeIcon },
    { key: 'country',      Icon: PublicIcon },
  ];

  // Icons for the two widget-level toggles, exposed so the settings popup +
  // status row render the same mark as the runtime widget.
  static detailsContactHideEmptyIcon = VisibilityOffIcon;
  static detailsContactEditIcon = EditIcon;

  // Composite value key under user.settings.userdetails_widgets.settings.
  // Bundles fields + hide_empty + edit so the settings dialog writes one key
  // (buildWidgetsPayload merges value + optional order key as siblings).
  static detailsContactValueKey = 'details_contact';

  // Per-field visibility state. Pure show/hide, no 'disabled' (fields are not
  // module-gated). Mirrors the actions widget's two-state model.
  // - 'shown'  : coach wants it visible
  // - 'hidden' : coach turned it off (field simply not rendered)
  static getDetailsContactFieldState = (item, visibility) => {
    return visibility?.[item.key] === false ? 'hidden' : 'shown';
  };

  // Returns the 5 fields in their fixed order, each tagged with `state`.
  // No order drift handling is needed (fixed order, no persisted order key),
  // but the shape matches the other widgets so callers stay uniform.
  static getOrderedDetailsContactFields = (visibility) => {
    return ClientWidgets.detailsContactItems.map((item) => ({
      ...item,
      state: ClientWidgets.getDetailsContactFieldState(item, visibility),
    }));
  };

  // ---------------------------------------------------------------------------
  // details_basic widget
  // ---------------------------------------------------------------------------
  //
  // The basic identity block (first/second/last name, call name, language).
  // Renders for every client type, but second_name and call_name only apply to
  // User::User (each field re-checks its gate in the widget). Same composite
  // shape as details_contact:
  //   { fields: Record<string,boolean>, hide_empty: boolean, edit: boolean }
  // No order setting — the 5 fields render in their fixed natural order. The
  // edit affordance is relocated from the old top-right IconButton to a
  // card-action footer (independently toggleable; navigates to the same edit
  // page as the contact widget's edit_contact and the actions widget's
  // edit_user, but a distinct surface with its own label key).

  static detailsBasicItems = [
    { key: 'first_name',  Icon: PersonIcon },
    { key: 'second_name', Icon: PersonOutlineIcon },
    { key: 'last_name',   Icon: DriveFileRenameOutlineIcon },
    { key: 'call_name',   Icon: BadgeIcon },
    { key: 'language',    Icon: TranslateIcon },
  ];

  static detailsBasicHideEmptyIcon = VisibilityOffIcon;
  static detailsBasicEditIcon = EditIcon;

  static detailsBasicValueKey = 'details_basic';

  static getDetailsBasicFieldState = (item, visibility) => {
    return visibility?.[item.key] === false ? 'hidden' : 'shown';
  };

  static getOrderedDetailsBasicFields = (visibility) => {
    return ClientWidgets.detailsBasicItems.map((item) => ({
      ...item,
      state: ClientWidgets.getDetailsBasicFieldState(item, visibility),
    }));
  };

  // ---------------------------------------------------------------------------
  // details_extra widget
  // ---------------------------------------------------------------------------
  //
  // The "other details" block (gender, spouse name, birth date, national
  // number). BaseMapper gates the whole widget on User::User, so every field
  // applies to a real user. Same composite shape as details_contact:
  //   { fields: Record<string,boolean>, hide_empty: boolean, edit: boolean }
  // No order setting — fixed natural order. Gender renders a translated label
  // for 0/1/2 and birth_date renders via a date formatter; both are kept as a
  // render node in the widget's FIELD_RENDER map (UI concern), same split as
  // the contact widget's composed address value.

  static detailsExtraItems = [
    { key: 'gender',          Icon: WcIcon },
    { key: 'spouse_name',     Icon: FavoriteIcon },
    { key: 'birth_date',      Icon: CakeIcon },
    { key: 'national_number', Icon: NumbersIcon },
  ];

  static detailsExtraHideEmptyIcon = VisibilityOffIcon;
  static detailsExtraEditIcon = EditIcon;

  static detailsExtraValueKey = 'details_extra';

  static getDetailsExtraFieldState = (item, visibility) => {
    return visibility?.[item.key] === false ? 'hidden' : 'shown';
  };

  static getOrderedDetailsExtraFields = (visibility) => {
    return ClientWidgets.detailsExtraItems.map((item) => ({
      ...item,
      state: ClientWidgets.getDetailsExtraFieldState(item, visibility),
    }));
  };

  // ---------------------------------------------------------------------------
  // consent_information widget
  // ---------------------------------------------------------------------------
  //
  // A list of per-client consent flags (enabled + the sub-consents), each
  // shown as a yes/pending/no row at runtime. The coach can choose which rows
  // to surface (on/off per consent) and in what order, mirroring the actions
  // widget's show/hide + order pattern.
  //
  // `enabled` is pinned on top: it's always first in the resolved order and is
  // NOT part of the persisted order key (the order key only holds the
  // reorderable sub-consents). It's still toggleable (a coach can hide its
  // row), but when shown it always leads — same fixed-first split as
  // picture_and_tags' fixed sections vs reorderable icon links.
  //
  // Sub-consents have a runtime `!is_secretary` gate in the widget (like
  // actions' per-row gates); the helper only owns data + pure logic. No module
  // gating, so no 'disabled' state — two-state shown/hidden, like actions.

  // The pinned-first consent. `pinned: true` marks it so getOrderedConsents
  // emits it first and excludes it from order drift handling.
  static consentItems = [
    { key: 'enabled',          pinned: true, Icon: CheckCircleIcon },
    { key: 'is_intake',        Icon: FactCheckIcon },
    { key: 'is_measure_weight', Icon: MonitorWeightIcon },
    { key: 'is_blood',         Icon: BloodtypeIcon },
    { key: 'is_diary_eat',     Icon: RestaurantIcon },
    { key: 'is_diary_move',    Icon: DirectionsRunIcon },
    { key: 'is_daynote',       Icon: EventNoteIcon },
  ];

  // Default order for the REORDERABLE sub-consents only (enabled is pinned
  // first and never appears here). Matches the widget's historical order.
  static defaultConsentsOrder = [
    'is_intake',
    'is_measure_weight',
    'is_blood',
    'is_diary_eat',
    'is_diary_move',
    'is_daynote',
  ];

  static consentsValueKey = 'consent_information';
  static consentsOrderKey = 'consent_information_order';

  // Icon for the widget-level "show consent logs" toggle, exposed so the
  // settings popup + status row render the same mark as the runtime widget's
  // logs footer button.
  static consentsShowLogsIcon = HistoryIcon;

  // i18n key for the note in the settings popup explaining that "hidden"
  // consents don't disappear — they move behind a "show all" toggle at runtime,
  // so a tucked sub-consent stays reachable. Mirrors the actions widget's
  // actionsNoteKey.
  static consentsNoteKey = 'coach.personal_settings.userdetail_widgets.settings.consent_information.note';

  // Per-consent visibility state. Pure show/hide, no 'disabled' (consents
  // aren't module-gated). Mirrors the actions widget's two-state model.
  // - 'shown'  : coach wants the row directly visible
  // - 'hidden' : coach tucked it behind a "show all" toggle at runtime
  static getConsentState = (item, visibility) => {
    return visibility?.[item.key] === false ? 'hidden' : 'shown';
  };

  // Resolves the render order for the consents widget: the pinned `enabled`
  // item first (if present), then the reorderable sub-consents in their
  // persisted order (falling back to the default and tolerating drift:
  // unknown keys ignored, missing keys appended). Each returned item carries
  // its resolved `state`; callers filter to 'shown' before rendering.
  static getOrderedConsents = (order, visibility) => {
    const pinnedItem = ClientWidgets.consentItems.find((i) => i.pinned);

    const reorderableItems = ClientWidgets.consentItems.filter((i) => !i.pinned);
    const fallbackOrder = ClientWidgets.defaultConsentsOrder;
    const resolvedOrder = (order && order.length > 0) ? order : fallbackOrder;

    const seen = new Set();
    const ordered = [];

    resolvedOrder.forEach((key) => {
      if (seen.has(key)) return;
      const item = reorderableItems.find((i) => i.key === key);
      if (!item) return; // ignore unknown keys
      seen.add(key);
      ordered.push(item);
    });

    // append any items missing from the resolved order (keeps new consents
    // visible if one is added later but the coach hasn't re-saved their order)
    reorderableItems.forEach((item) => {
      if (seen.has(item.key)) return;
      ordered.push(item);
    });

    const tagged = ordered.map((item) => ({
      ...item,
      state: ClientWidgets.getConsentState(item, visibility),
    }));

    // Pinned `enabled` leads, regardless of persisted order. It's still
    // state-tagged so the show/hide toggle applies.
    if (pinnedItem) {
      return [{
        ...pinnedItem,
        state: ClientWidgets.getConsentState(pinnedItem, visibility),
      }, ...tagged];
    }
    return tagged;
  };

  // ---------------------------------------------------------------------------
  // notification_information widget
  // ---------------------------------------------------------------------------
  //
  // A read-only block showing the viewed client's two email-notification
  // preferences (nutri_appointment, nutri_workshop) as yes/no rows. The coach
  // can choose which rows to surface (on/off per notification); the yes/no
  // value itself still comes from the client's settings
  // (object.settings.notifications.*), so this is a pure visibility filter,
  // not a value editor.
  //
  // This is the simplest settings shape in the module: a plain per-item
  // Record<string,boolean> under one value key (`notification_information`),
  // no order setting (only 2 items in their fixed natural order), and no
  // widget-level toggles — so no composite-value wrapper is needed (the
  // composite-value convention only kicks in when a widget has multiple
  // settings of different shapes). Mirrors the actions widget's two-state
  // model (shown/hidden), minus the order + show-all overflow.

  // The two notification rows, in their fixed render order. `Icon` matches the
  // sidebar's icon for each module (CalendarMonth for appointments, CoPresent
  // for workshops) so the status row + popup stay visually consistent with the
  // navigation. No `moduleChecks`: the widget is NOT module-gated — it simply
  // reports the client's saved preference regardless of which modules the
  // practice has, so no 'disabled' state.
  static notificationItems = [
    { key: 'nutri_appointment', Icon: CalendarMonthIcon },
    { key: 'nutri_workshop',    Icon: CoPresentIcon },
  ];

  static notificationsValueKey = 'notification_information';

  // Per-notification visibility state. Pure show/hide, no 'disabled' (the
  // widget isn't module-gated). Mirrors the actions widget's two-state model.
  // - 'shown'  : coach wants the row visible
  // - 'hidden' : coach turned the row off (not rendered)
  static getNotificationItemState = (item, visibility) => {
    return visibility?.[item.key] === false ? 'hidden' : 'shown';
  };

  // Returns the 2 notifications in their fixed order, each tagged with
  // `state`. No order drift handling is needed (fixed order, no persisted
  // order key), but the shape matches the other widgets so callers stay uniform.
  static getOrderedNotificationItems = (visibility) => {
    return ClientWidgets.notificationItems.map((item) => ({
      ...item,
      state: ClientWidgets.getNotificationItemState(item, visibility),
    }));
  };

  // ---------------------------------------------------------------------------
  // mollie_links_small widget
  // ---------------------------------------------------------------------------
  //
  // The payment-links (Mollie) module widget on the client detail page. No
  // per-row visibility settings (the last-5 list is data, not config), so its
  // settings are two widget-level toggles:
  //   { cta: boolean, show_links: boolean }
  // - `cta`        : on/off for the bottom "goto payment links" button
  //                 (premium-locked when the payments module is off). On by
  //                 default.
  // - `show_links` : on/off for the last-5 payment links list. On by default.
  //                 The summary counts line always renders — only the list
  //                 itself is toggled.
  // Minimal object (not a bare bool) so future sub-settings can be added
  // without a data migration. No order setting — nothing to reorder.

  static mollieLinksSmallValueKey = 'mollie_links_small';

  // Icons for the two widget-level toggles, exposed so the settings popup +
  // status row render the same marks the sidebar uses for the payments module
  // (Euro) and the standard link mark for the links list.
  static mollieLinksSmallCtaIcon = Euro;
  static mollieLinksSmallLinksIcon = LinkIcon;

  // Pure getters for the two toggles (default on) — used by both the settings
  // popup and the runtime widget so the defaults live in one place.
  static getMollieLinksSmallCtaEnabled = (value) => {
    return value?.cta !== false;
  };

  static getMollieLinksSmallLinksEnabled = (value) => {
    return value?.show_links !== false;
  };

  // ---------------------------------------------------------------------------
  // appointments_small widget
  // ---------------------------------------------------------------------------
  //
  // The appointments module widget on the client detail page. Like
  // mollie_links_small there are no per-row visibility settings — the widget
  // body is data (stats counts or a last-5 list), not config. Its settings
  // are three widget-level values:
  //   { cta: boolean, mode: 'stats' | 'list' }
  // - `cta`  : on/off for the bottom "goto appointments" button (premium-
  //           locked when the nutri_appointment module is off). On by default.
  // - `mode` : which body the widget renders — 'stats' (x in the past /
  //           y in the future counts, the default) or 'list' (the last 5
  //           appointments, newest first).
  // No order setting — nothing to reorder.

  static appointmentsSmallValueKey = 'appointments_small';

  // Icons for the widget-level settings, exposed so the settings popup +
  // status row render the same marks: CalendarMonth matches the sidebar's
  // appointments module icon; the two mode icons mark the stats vs list body.
  static appointmentsSmallCtaIcon = CalendarMonthIcon;
  static appointmentsSmallStatsIcon = BarChartIcon;
  static appointmentsSmallListIcon = ViewListIcon;

  // The two selectable modes for the appointments_small body, in buttongroup
  // order. `key` is the persisted value; `Icon` marks it in popup + status.
  static appointmentsSmallModes = [
    { key: 'stats', Icon: BarChartIcon },
    { key: 'list',  Icon: ViewListIcon },
  ];

  // Pure getters (defaults: cta on, stats mode) — used by both the settings
  // popup and the runtime widget so the defaults live in one place.
  static getAppointmentsSmallCtaEnabled = (value) => {
    return value?.cta !== false;
  };

  static getAppointmentsSmallMode = (value) => {
    const mode = ClientWidgets.appointmentsSmallModes.find((m) => m.key === value?.mode);
    return mode ? mode.key : 'stats';
  };

  // ---------------------------------------------------------------------------
  // courses_small widget (e-learning)
  // ---------------------------------------------------------------------------
  //
  // The knowledge courses widget on the client detail page. Same shape as
  // appointments_small: no per-row visibility settings — the body is data
  // (stats counts or a last-5 subscriptions list), not config. Settings are:
  //   { cta: boolean, mode: 'stats' | 'list' }
  // - `cta`  : on/off for the top-right "goto courses" button (premium-
  //           locked when the knowledge module is off). On by default.
  // - `mode` : which body the widget renders — 'stats' (x participating /
  //           y total counts, the default) or 'list' (the client's last 5
  //           course subscriptions by last_activity, newest first).
  // No order setting — nothing to reorder.

  static coursesSmallValueKey = 'courses_small';

  // Icons for the widget-level settings, exposed so the settings popup +
  // status row render the same marks: SchoolIcon matches the sidebar's
  // knowledge courses module icon; the two mode icons mark the stats vs
  // list body.
  static coursesSmallCtaIcon = SchoolIcon;
  static coursesSmallStatsIcon = BarChartIcon;
  static coursesSmallListIcon = ViewListIcon;

  // The two selectable modes for the courses_small body, in buttongroup
  // order. `key` is the persisted value; `Icon` marks it in popup + status.
  static coursesSmallModes = [
    { key: 'stats', Icon: BarChartIcon },
    { key: 'list',  Icon: ViewListIcon },
  ];

  // Pure getters (defaults: cta on, stats mode) — used by both the settings
  // popup and the runtime widget so the defaults live in one place.
  static getCoursesSmallCtaEnabled = (value) => {
    return value?.cta !== false;
  };

  static getCoursesSmallMode = (value) => {
    const mode = ClientWidgets.coursesSmallModes.find((m) => m.key === value?.mode);
    return mode ? mode.key : 'stats';
  };

  // ---------------------------------------------------------------------------
  // questionnaires_small widget
  // ---------------------------------------------------------------------------
  //
  // The questionnaires widget on the client detail page. Same shape as
  // appointments_small / courses_small: no per-row visibility settings — the
  // body is data (stats counts or a last-5 results list), not config.
  // Settings are:
  //   { cta: boolean, mode: 'stats' | 'list' }
  // - `cta`  : on/off for the top-right "goto questionnaires" button
  //           (premium-locked when the questionnaire module is off). On by
  //           default.
  // - `mode` : which body the widget renders — 'stats' (x invited / y
  //           completed counts, the default) or 'list' (the client's last 5
  //           questionnaire results by updated_at, newest first — updated_at
  //           bumps on invite, mail resend and completion alike).
  // No order setting — nothing to reorder.

  static questionnairesSmallValueKey = 'questionnaires_small';

  // Icons for the widget-level settings, exposed so the settings popup +
  // status row render the same marks: QuizIcon matches the sidebar's
  // questionnaires module icon; the two mode icons mark the stats vs list
  // body.
  static questionnairesSmallCtaIcon = QuizIcon;
  static questionnairesSmallStatsIcon = BarChartIcon;
  static questionnairesSmallListIcon = ViewListIcon;

  // The two selectable modes for the questionnaires_small body, in
  // buttongroup order. `key` is the persisted value; `Icon` marks it in
  // popup + status.
  static questionnairesSmallModes = [
    { key: 'stats', Icon: BarChartIcon },
    { key: 'list',  Icon: ViewListIcon },
  ];

  // Pure getters (defaults: cta on, stats mode) — used by both the settings
  // popup and the runtime widget so the defaults live in one place.
  static getQuestionnairesSmallCtaEnabled = (value) => {
    return value?.cta !== false;
  };

  static getQuestionnairesSmallMode = (value) => {
    const mode = ClientWidgets.questionnairesSmallModes.find((m) => m.key === value?.mode);
    return mode ? mode.key : 'stats';
  };

  // ---------------------------------------------------------------------------
  // measures_small widget
  // ---------------------------------------------------------------------------
  //
  // The weight-measures module widget on the client detail page. Like the
  // other _small module widgets the body is data, not config, so its single
  // setting is a mode picker choosing which body to render:
  //   { mode: 'last_weight' | 'graph' }
  // - 'last_weight' (default): the client's latest weight entry — a big
  //   weight number + its date + the goal-weight line, from the
  //   custom_api_last_weight custom action (the client dashboard's source).
  // - 'graph' : the CoachUserMeasures chart block — weight + goal lines over
  //   the last 30/60 days with month navigation, from custom_api_weight_stats
  //   (the exact query the measures page uses, minus its delete-point dot).
  // - 'episode_loss' + 'bmi': planned modes, disabled for now (rendered grey
  //   in the settings ButtonGroup, never returned by the getter).
  // The old goto-measures button and the blood-uploads sub-section were
  // removed from the widget (the goto_links widget and the file page cover
  // navigation; blood lives on the blood page). Minimal object (not a bare
  // string) so future sub-settings can be added without a data migration.
  // No order setting — nothing to reorder.

  static measuresSmallValueKey = 'measures_small';

  // The four selectable modes for the measures_small body, in buttongroup
  // order. `key` is the persisted value; `Icon` marks it in popup + status.
  // `disabled` marks the not-yet-implemented modes (greyed out in the
  // ButtonGroup; the getter never resolves to them).
  static measuresSmallModes = [
    { key: 'last_weight',  Icon: MonitorWeightIcon },
    { key: 'graph',        Icon: ShowChartIcon },
    { key: 'episode_loss', Icon: TrendingDownIcon, disabled: true },
    { key: 'bmi',          Icon: CalculateIcon, disabled: true },
  ];

  // Pure getter (default: last_weight mode). Falls back to 'last_weight' on
  // unknown values AND on disabled modes (a stale persisted 'bmi' from a
  // future version should never break this one).
  static getMeasuresSmallMode = (value) => {
    const mode = ClientWidgets.measuresSmallModes.find(
      (m) => m.key === value?.mode && !m.disabled
    );
    return mode ? mode.key : 'last_weight';
  };

  // ---------------------------------------------------------------------------
  // diary_small widget
  // ---------------------------------------------------------------------------
  //
  // The diary module widget on the client detail page. The body rows are
  // coach-configurable (show/hide + order) via the goto_links pattern, plus
  // one widget-level `cta` toggle (not part of the orderable list):
  //   eat_group     : the client's eat-diary group for this practice (+ adjust
  //                   dialog + premium overlay) — gated on nutri_diary_eat
  //   move_group    : the same for the move diary — gated on nutri_diary_move
  //   last_entry    : "last entry" date from module_status.diary_day (any
  //                   diary data, not module-gated)
  //   daynote_client: the client's most recent own note on a diary day
  //                   (diary_day.client_note, hidden-from-this-practice
  //                   respected) — new row
  //   daynote_coach : the most recent coach feedback on the client's diary
  //                   days (the feedbacks assoc for this practice, internal
  //                   or external — the coach.diary.feedbacks dialog's data)
  //                   — new row
  // The two daynote rows share one diary_day query (day DESC, 30 scanned) in
  // the widget; which practice's feedbacks count is a runtime concern.
  // The top-right "goto diary" CTA follows the module's shared cta pattern:
  // a small text button absolute in the title row, toggleable via the
  // composite `cta` key (default on), NOT part of the orderable list.

  static diarySmallItems = [
    { key: 'eat_group',      moduleChecks: ['nutri_diary_eat'],  Icon: RestaurantIcon },
    { key: 'move_group',     moduleChecks: ['nutri_diary_move'], Icon: DirectionsRunIcon },
    { key: 'last_entry',     moduleChecks: [],                   Icon: TodayIcon },
    { key: 'daynote_client', moduleChecks: [],                   Icon: NotesIcon },
    { key: 'daynote_coach',  moduleChecks: [],                   Icon: InsertCommentIcon },
  ];

  // Icon for the widget-level `cta` toggle, exposed so the settings popup +
  // status row render the same mark (MenuBook = the sidebar's diary mark).
  static diarySmallCtaIcon = MenuBookIcon;

  // Canonical default order, matching the widget's historical layout with
  // the two daynote rows appended after last_entry. The CTA is not listed —
  // it's a fixed top-right button, not an orderable row.
  static defaultDiarySmallOrder = [
    'eat_group',
    'move_group',
    'last_entry',
    'daynote_client',
    'daynote_coach',
  ];

  static diarySmallValueKey = 'diary_small';
  static diarySmallOrderKey = 'diary_small_order';

  // Pure getter for the `cta` toggle (default on) — used by both the settings
  // popup and the runtime widget so the default lives in one place.
  static getDiarySmallCtaEnabled = (value) => {
    return value?.cta !== false;
  };

  // Per-row visibility state, mirroring goto_links' three-state model:
  // - 'active'   : module active and shown (primary)
  // - 'inactive' : module active but hidden by the coach (secondary)
  // - 'disabled' : module not active, can't be shown (grey)
  static getDiarySmallItemState = (item, visibility, currentPractice) => {
    const moduleActive = item.moduleChecks.length === 0
      ? true
      : item.moduleChecks.some((check) => !!HelpersPractice.practice_modules_v3({practice: currentPractice, check}));
    if (!moduleActive) return 'disabled';
    // default visible unless explicitly hidden
    return visibility?.[item.key] !== false ? 'active' : 'inactive';
  };

  // Resolves the render order for the diary widget. Falls back to the
  // default order when none is persisted and tolerates drift (unknown keys
  // ignored; missing keys appended at the end). Each returned item carries
  // its resolved `state`; callers filter to 'active' before rendering.
  static getOrderedDiarySmallItems = (order, visibility, currentPractice) => {
    const fallbackOrder = ClientWidgets.defaultDiarySmallOrder;
    const resolvedOrder = (order && order.length > 0) ? order : fallbackOrder;

    const seen = new Set();
    const ordered = [];

    resolvedOrder.forEach((key) => {
      if (seen.has(key)) return;
      const item = ClientWidgets.diarySmallItems.find((i) => i.key === key);
      if (!item) return; // ignore unknown keys
      seen.add(key);
      ordered.push(item);
    });

    // append any items missing from the resolved order (keeps new rows
    // visible if one is added later but the coach hasn't re-saved their order)
    ClientWidgets.diarySmallItems.forEach((item) => {
      if (seen.has(item.key)) return;
      ordered.push(item);
    });

    return ordered.map((item) => ({
      ...item,
      state: ClientWidgets.getDiarySmallItemState(item, visibility, currentPractice),
    }));
  };

  // ---------------------------------------------------------------------------
  // files_small widget
  // ---------------------------------------------------------------------------
  //
  // The client file widget. The old button-stack (4 goto buttons) became 7
  // orderable static stat rows + a single top-right goto CTA. Composite
  // value under one key + a sibling order key (the consent_information
  // pattern — per-item list + widget-level toggle of different shapes):
  //   { cta: boolean, items: Record<string,boolean> }
  // - `cta`   : on/off for the top-right "goto file" button. On by default.
  // - `items` : per-stat show/hide. Pure two-state (shown/hidden), like
  //             actions — no module gating (module checks live on the file
  //             page's tabs, not on these statics).
  // `files_small_order`: render order of all 7 items (no pinned first —
  // everything is reorderable).
  // Hidden items are gone at runtime (no show-all overflow): every stat is
  // still reachable on the file page itself.

  // The 7 stats, in default order. `Icon` is shown in the settings popup +
  // status row, matching the file-page tab icons where one exists.
  static filesSmallItems = [
    { key: 'episode',                Icon: RepeatIcon },        // active episode
    { key: 'intake_stats',           Icon: BackupTableIcon },   // intake profile stats
    { key: 'uploads_stats',          Icon: TodayIcon },         // latest-upload date
    { key: 'timeline_stats',         Icon: VaccinesIcon },      // ex-msbo: entries + last end date
    { key: 'treatment_plan_stats',   Icon: MedicationIcon },    // treatment plan updated_at + editor
    { key: 'advices_count',          Icon: EscalatorWarningIcon }, // number of advices
    { key: 'uploads_count',          Icon: ImageSearchIcon },   // number of uploads
  ];

  static defaultFilesSmallOrder = [
    'episode',
    'intake_stats',
    'uploads_stats',
    'timeline_stats',
    'treatment_plan_stats',
    'advices_count',
    'uploads_count',
  ];

  static filesSmallValueKey = 'files_small';
  static filesSmallOrderKey = 'files_small_order';

  // Icon for the widget-level `cta` toggle, exposed so the settings popup +
  // status row render the same mark the runtime CTA uses (FolderIcon = the
  // file module's generic mark).
  static filesSmallCtaIcon = FolderIcon;

  // Per-stat visibility state. Pure show/hide, no 'disabled' — two-state,
  // like actions.
  static getFilesSmallItemState = (item, visibility) => {
    return visibility?.[item.key] === false ? 'hidden' : 'shown';
  };

  // Resolves the render order for the file stats: persisted order with
  // default fallback + drift tolerance (unknown keys ignored, missing keys
  // appended). Each returned item carries its resolved `state`; callers
  // filter to 'shown' before rendering.
  static getOrderedFilesSmallItems = (order, visibility) => {
    const fallbackOrder = ClientWidgets.defaultFilesSmallOrder;
    const resolvedOrder = (order && order.length > 0) ? order : fallbackOrder;

    const seen = new Set();
    const ordered = [];

    resolvedOrder.forEach((key) => {
      if (seen.has(key)) return;
      const item = ClientWidgets.filesSmallItems.find((i) => i.key === key);
      if (!item) return; // ignore unknown keys
      seen.add(key);
      ordered.push(item);
    });

    // append any items missing from the resolved order (keeps new stats
    // visible if one is added later but the coach hasn't re-saved their order)
    ClientWidgets.filesSmallItems.forEach((item) => {
      if (seen.has(item.key)) return;
      ordered.push(item);
    });

    return ordered.map((item) => ({
      ...item,
      state: ClientWidgets.getFilesSmallItemState(item, visibility),
    }));
  };

  // ---------------------------------------------------------------------------
  // basic_intake widget
  // ---------------------------------------------------------------------------
  //
  // The intake-profile file widget on the client detail page. The body rows
  // are data, not config, so its settings are a single widget-level toggle:
  //   { cta: boolean }
  // - `cta` : on/off for the top-right "goto intake" button. On by default.
  // No per-row settings and no order setting — nothing to reorder.

  static basicIntakeValueKey = 'basic_intake';

  // Icon for the widget-level `cta` toggle, exposed so the settings popup +
  // status row render the same mark the file stats use for the intake rows
  // (BackupTable = the intake profile stats mark).
  static basicIntakeCtaIcon = BackupTableIcon;

  // Pure getter for the `cta` toggle (default on) — used by both the settings
  // popup and the runtime widget so the default lives in one place.
  static getBasicIntakeCtaEnabled = (value) => {
    return value?.cta !== false;
  };

  // ---------------------------------------------------------------------------
  // basic_treatment widget
  // ---------------------------------------------------------------------------
  //
  // The treatment-plan file widget on the client detail page. Same shape as
  // basic_intake: the body rows are data, not config, so its settings are a
  // single widget-level toggle:
  //   { cta: boolean }
  // - `cta` : on/off for the top-right "goto treatment plan" button. On by
  //           default.
  // No per-row settings and no order setting — nothing to reorder.

  static basicTreatmentValueKey = 'basic_treatment';

  // Icon for the widget-level `cta` toggle, exposed so the settings popup +
  // status row render the same mark the file stats use for the treatment-plan
  // rows (Medication = the treatment-plan stats mark; MedicationAdd is not in
  // the installed @mui/icons-material yet).
  static basicTreatmentCtaIcon = MedicationIcon;

  // Pure getter for the `cta` toggle (default on) — used by both the settings
  // popup and the runtime widget so the default lives in one place.
  static getBasicTreatmentCtaEnabled = (value) => {
    return value?.cta !== false;
  };

  // ---------------------------------------------------------------------------
  // basic_advice widget
  // ---------------------------------------------------------------------------
  //
  // The advices file widget on the client detail page. Static stat rows + a
  // top-right goto CTA, the exact files_small pattern (per-item list +
  // widget-level toggle of different shapes bundled under one key + a sibling
  // order key):
  //   { cta: boolean, items: Record<string,boolean> }
  // - `cta`   : on/off for the top-right "goto advices" button. On by default.
  // - `items` : per-stat show/hide. Pure two-state (shown/hidden), like
  //             actions — the rows are statics, no module gating.
  // `basic_advice_order`: render order of all 6 items (no pinned first —
  // everything is reorderable). Hidden items are gone at runtime (no show-all
  // overflow): every stat is still reachable on the advices page itself.

  // The 6 stats, in default order. `Icon` is shown in the settings popup +
  // status row; the keys mirror the advice fields (AdvicesNew's columns).
  static basicAdviceItems = [
    { key: 'count',     Icon: NumbersIcon },       // number of advices
    { key: 'goals',     Icon: FlagIcon },          // goals feedback present
    { key: 'deals',     Icon: HandshakeIcon },     // deals feedback present
    { key: 'education', Icon: SchoolIcon },        // education feedback present
    { key: 'next_time', Icon: ScheduleIcon },      // next appointment hint
    { key: 'weight',    Icon: MonitorWeightIcon }, // advice weight entry
  ];

  static defaultBasicAdviceOrder = [
    'count',
    'goals',
    'deals',
    'education',
    'next_time',
    'weight',
  ];

  static basicAdviceValueKey = 'basic_advice';
  static basicAdviceOrderKey = 'basic_advice_order';

  // Icon for the widget-level `cta` toggle, exposed so the settings popup +
  // status row render the same mark the file stats use for the advices count
  // (EscalatorWarning = the advices mark).
  static basicAdviceCtaIcon = EscalatorWarningIcon;

  // Pure getter for the `cta` toggle (default on) — used by both the settings
  // popup and the runtime widget so the default lives in one place.
  static getBasicAdviceCtaEnabled = (value) => {
    return value?.cta !== false;
  };

  // Per-stat visibility state. Pure show/hide, no 'disabled' — two-state,
  // like actions.
  static getBasicAdviceItemState = (item, visibility) => {
    return visibility?.[item.key] === false ? 'hidden' : 'shown';
  };

  // Resolves the render order for the advice stats: persisted order with
  // default fallback + drift tolerance (unknown keys ignored, missing keys
  // appended). Each returned item carries its resolved `state`; callers
  // filter to 'shown' before rendering.
  static getOrderedBasicAdviceItems = (order, visibility) => {
    const fallbackOrder = ClientWidgets.defaultBasicAdviceOrder;
    const resolvedOrder = (order && order.length > 0) ? order : fallbackOrder;

    const seen = new Set();
    const ordered = [];

    resolvedOrder.forEach((key) => {
      if (seen.has(key)) return;
      const item = ClientWidgets.basicAdviceItems.find((i) => i.key === key);
      if (!item) return; // ignore unknown keys
      seen.add(key);
      ordered.push(item);
    });

    // append any items missing from the resolved order (keeps new stats
    // visible if one is added later but the coach hasn't re-saved their order)
    ClientWidgets.basicAdviceItems.forEach((item) => {
      if (seen.has(item.key)) return;
      ordered.push(item);
    });

    return ordered.map((item) => ({
      ...item,
      state: ClientWidgets.getBasicAdviceItemState(item, visibility),
    }));
  };

  // ---------------------------------------------------------------------------
  // basic_measure_uploads widget
  // ---------------------------------------------------------------------------
  //
  // The measure-uploads file widget on the client detail page (weight + blood
  // uploads). The rows are data, not config, so its settings are three
  // independently toggleable parts, the communication pattern:
  //   { counts: boolean, list: boolean, cta: boolean }
  // - `counts`: the uploads summary counts line. On by default.
  // - `list`  : the newest uploads list. On by default.
  // - `cta`   : on/off for the top-right "goto uploads" button. On by default.
  // No per-row settings and no order setting — nothing to reorder.

  static basicMeasureUploadsValueKey = 'basic_measure_uploads';

  // Icons for the widget-level toggles, exposed so the settings popup +
  // status row render the same marks (Bloodtype = the blood-uploads mark,
  // BarChart/ViewList = the counts/list pair the communication widgets use).
  static basicMeasureUploadsCtaIcon = BloodtypeIcon;
  static basicMeasureUploadsCountsIcon = BarChartIcon;
  static basicMeasureUploadsListIcon = ViewListIcon;

  // Pure getters for the three toggles (default on) — used by both the
  // settings popup and the runtime widget so the defaults live in one place.
  static getBasicMeasureUploadsCtaEnabled = (value) => {
    return value?.cta !== false;
  };

  static getBasicMeasureUploadsCountsEnabled = (value) => {
    return value?.counts !== false;
  };

  static getBasicMeasureUploadsListEnabled = (value) => {
    return value?.list !== false;
  };

  // ---------------------------------------------------------------------------
  // communication_nutri / communication_ehealth / communication_zorg widgets
  // ---------------------------------------------------------------------------
  //
  // The three mail widgets on the client detail page (NutriMail, eHealth mail
  // and ZorgMail). All three render the same body from a different source, so
  // they share one settings shape — three independently toggleable parts:
  //   { counts: boolean, list: boolean, cta: boolean }
  // - `counts`: the "x ontvangen · y verzonden" summary line. On by default.
  // - `list`  : the newest-5 mails list (received + sent merged, newest
  //             first). On by default.
  // - `cta`   : the top-right goto button to the source's inbox. On by
  //             default. Premium-locked when the module is off (ehealth/zorg
  //             open their init dialog instead when only the credentials are
  //             missing).
  // No per-row settings (the rows are data, not config) and no order setting.
  // One shared getter set + per-widget value keys; the runtime body is one
  // shared CommunicationSmall.tsx parameterised by source.

  static communicationNutriValueKey = 'communication_nutri';
  static communicationEhealthValueKey = 'communication_ehealth';
  static communicationZorgValueKey = 'communication_zorg';

  // Icons for the widget-level toggles, exposed so the settings popup +
  // status row render the same marks for every source (BarChart = the counts
  // line, ViewList = the last-5 list — the same pair appointments_small uses
  // for its stats/list modes; Mail = the goto-inbox CTA).
  static communicationSmallCountsIcon = BarChartIcon;
  static communicationSmallListIcon = ViewListIcon;
  static communicationSmallCtaIcon = MailIcon;

  // Pure getters for the three toggles (default on) — used by both the
  // settings popup and the runtime widget so the defaults live in one place.
  static getCommunicationSmallCountsEnabled = (value) => {
    return value?.counts !== false;
  };

  static getCommunicationSmallListEnabled = (value) => {
    return value?.list !== false;
  };

  static getCommunicationSmallCtaEnabled = (value) => {
    return value?.cta !== false;
  };

  // ---------------------------------------------------------------------------
  // basic_advice_uploads widget
  // ---------------------------------------------------------------------------
  //
  // The advice-uploads file widget on the client detail page. Same shape as
  // basic_measure_uploads: three independently toggleable parts, no order.

  static basicAdviceUploadsValueKey = 'basic_advice_uploads';

  static basicAdviceUploadsCtaIcon = ImageSearchIcon;
  static basicAdviceUploadsCountsIcon = BarChartIcon;
  static basicAdviceUploadsListIcon = ViewListIcon;

  static getBasicAdviceUploadsCtaEnabled = (value) => {
    return value?.cta !== false;
  };

  static getBasicAdviceUploadsCountsEnabled = (value) => {
    return value?.counts !== false;
  };

  static getBasicAdviceUploadsListEnabled = (value) => {
    return value?.list !== false;
  };

  // ---------------------------------------------------------------------------
  // timeline widget
  // ---------------------------------------------------------------------------
  //
  // The medication timeline widget: how many entries it shows (5/7/10, 5 by
  // default) + whether the goto CTA renders.

  static timelineValueKey = 'timeline';

  static timelineCtaIcon = VaccinesIcon;

  static timelineAmounts = [
    { key: 5 },
    { key: 7 },
    { key: 10 },
  ];

  static getTimelineCtaEnabled = (value) => {
    return value?.cta !== false;
  };

  static getTimelineAmount = (value) => {
    return ClientWidgets.timelineAmounts.some((a) => a.key === value?.amount) ? value.amount : 5;
  };

  // ---------------------------------------------------------------------------
  // basic_sleep widget
  // ---------------------------------------------------------------------------
  //
  // The sleep-tracking widget on the client detail page. The body is data
  // (the client's latest sleep/wake entry), not config, so the helper only
  // owns the value key + the pure mapping from custom_api_wake_stats data
  // (chronological, like the client Wake page's chart source).

  static basicSleepValueKey = 'basic_sleep';

  static getBasicSleepLastEntry = (stats) => {
    const entries = (stats || []).filter((entry) => !!entry.wake || !!entry.sleep);
    const last = entries[entries.length - 1];
    if (!last) return null;
    return {
      day: last.name,
      sleepString: last.sleep_string,
      wakeString: last.wake_string,
    };
  };

  // ---------------------------------------------------------------------------
  // workshops widget
  // ---------------------------------------------------------------------------
  //
  // The workshops module widget on the client detail page. The body is data
  // (the practice's upcoming workshops), not config: the caller fetches the
  // rows newest-first and this helper filters + maps them for display.

  static workshopsValueKey = 'workshops';

  static getWorkshopsRows = (workshops) => {
    return (workshops || [])
      .filter((workshop) => !workshop.is_cancelled)
      .slice(0, 5)
      .map((workshop) => ({
        id: workshop.id,
        subject: workshop.subject,
        startTime: workshop.start_time,
        subscribedCount: (workshop.get_subscriber_ids || []).length,
        backupsCount: (workshop.get_backup_ids || []).length,
      }));
  };

  // ---------------------------------------------------------------------------
  // status widget
  // ---------------------------------------------------------------------------
  //
  // Chronologische tijdlijn van de client: elke aan-gevinkte source levert
  // "knooppunten" (dag + actie + wie), de frontend sorteert ze op tijd
  // (nieuwste eerst). Daarom NIET sorteerbaar in de settings — de sortering
  // is afgeleid, geen voorkeur.
  //
  // Consents en modules worden als `consentChecks`/`moduleChecks` op het item
  // gezet; de runtime negeert sources waarvan de check faalt (en de settings
  // disablet de switch).
  //
  // `last` op een item (optioneel) betekent "toon enkel de laatste gebeurtenis,
  // met aantal" — de fetch haalt dan per_page 1 + count op. Voor sources
  // waarvan de API geen totaal kan tellen (weights via custom action) staat
  // `countable: false` en toont de knoop enkel de laatste datum.

  static statusValueKey = 'status';

  static statusCtaIcon = InsightsIcon;

  static statusAmounts = [
    { key: 10 },
    { key: 20 },
    { key: 30 },
  ];

  // De sources, in vaste volgorde. Bewust gegroepeerd: de klantlijst
  // navolgd, met de ehealth/elearning dagelijkse gang van zaken ernaast.
  static statusItems = [
    // basis
    { key: 'client_created',          Icon: PersonAddIcon },
    { key: 'last_login',              Icon: LoginIcon },
    { key: 'appointment',             Icon: CalendarMonthIcon,   moduleChecks: ['nutri_appointment'] },
    { key: 'appointment_paid',        Icon: CreditCardIcon,      moduleChecks: ['nutri_appointment'] },
    { key: 'intake_coach',            Icon: AssignmentIcon,      consentChecks: ['is_intake'] },
    { key: 'intake_client',           Icon: AssignmentIcon,      consentChecks: ['is_intake'] },
    { key: 'research_uploads',        Icon: ImageSearchIcon,     consentChecks: ['is_blood'] },
    { key: 'timeline_filled',         Icon: VaccinesIcon,        consentChecks: ['is_intake'] },
    { key: 'treatment_plan',          Icon: MedicationIcon,      consentChecks: ['is_intake'] },
    { key: 'treatment_plan_feedback', Icon: FeedbackIcon,        consentChecks: ['is_intake'] },
    { key: 'consult_created',         Icon: EscalatorWarningIcon, consentChecks: ['is_intake'] },
    { key: 'consult_feedback',        Icon: TextsmsIcon,         consentChecks: ['is_intake'] },
    { key: 'attachment_added',        Icon: AttachFileIcon,      consentChecks: ['is_intake'] },
    // vragenlijsten
    { key: 'questionnaire_created',   Icon: QuizIcon,            moduleChecks: ['questionnaire'] },
    { key: 'questionnaire_reminder',  Icon: ScheduleIcon,        moduleChecks: ['questionnaire'] },
    { key: 'questionnaire_received',  Icon: FactCheckIcon,       moduleChecks: ['questionnaire'] },
    { key: 'questionnaire_locked',    Icon: CheckCircleIcon,     moduleChecks: ['questionnaire'] },
    // elearning
    { key: 'elearning_invite',        Icon: SchoolIcon,          moduleChecks: ['knowledge'] },
    { key: 'elearning_payment',       Icon: Euro,                moduleChecks: ['knowledge'] },
    { key: 'elearning_status',        Icon: SchoolIcon,          moduleChecks: ['knowledge'] },
    // mails
    { key: 'nutrimail_received',      Icon: EmailIcon,           moduleChecks: ['nutri_mail'] },
    { key: 'nutrimail_sent',          Icon: SendIcon,            moduleChecks: ['nutri_mail'] },
    { key: 'ehealth_received',        Icon: MarkEmailUnreadIcon, moduleChecks: ['ehealth'] },
    { key: 'ehealth_sent',            Icon: OutboxIcon,         moduleChecks: ['ehealth'] },
    { key: 'zorgmail_received',       Icon: LocalPostOfficeIcon, moduleChecks: ['zorg_mail'] },
    { key: 'zorgmail_sent',           Icon: LocalShippingIcon,   moduleChecks: ['zorg_mail'] },
    // betalingen
    { key: 'mollie_link',             Icon: LinkIcon,            moduleChecks: ['payments'] },
    { key: 'mollie_link_paid',        Icon: Euro,                moduleChecks: ['payments'] },
    // dagboek
    { key: 'eat_diary',               Icon: RestaurantIcon,      moduleChecks: ['nutri_diary_eat'],  last: true },
    { key: 'eat_diary_feedback',      Icon: CommentIcon,         moduleChecks: ['nutri_diary_eat'],  last: true },
    { key: 'move_diary',              Icon: DirectionsRunIcon,   moduleChecks: ['nutri_diary_move'], last: true },
    { key: 'move_diary_feedback',     Icon: CommentIcon,         moduleChecks: ['nutri_diary_move'], last: true },
    { key: 'sleep_times',             Icon: BedtimeIcon,         moduleChecks: [],                   last: true, countable: false },
    { key: 'weight_client',           Icon: MonitorWeightIcon,   moduleChecks: [],                   last: true, countable: false },
    { key: 'daynote_client',          Icon: NotesIcon,           moduleChecks: [],                   last: true },
    { key: 'daynote_coach',           Icon: InsertCommentIcon,   moduleChecks: [],                   last: true },
  ];

  static getStatusCtaEnabled = (value) => {
    return value?.cta !== false;
  };

  static getStatusAmount = (value) => {
    return ClientWidgets.statusAmounts.some((a) => a.key === value?.amount) ? value.amount : 10;
  };

  // Drie-state model (goto_links): 'active' = aangetoond, 'inactive' = uitgevinkt,
  // 'disabled' = module/consent uit — kan niet aan. Module-checks zijn
  // practice-niveau (geldig in de settings, geen client nodig). Consent-checks
  // zijn client-niveau: zonder consent-info (null — de settings-context) wordt
  // NIET gegated; op runtime past de widget ze toe op de bekeken client.
  static getStatusItemState = (item, visibility, currentPractice, consentStatus) => {
    const moduleActive = (item.moduleChecks || []).length === 0
      ? true
      : item.moduleChecks.some((check) => !!HelpersPractice.practice_modules_v3({practice: currentPractice, check}));
    if (!moduleActive) return 'disabled';
    if ((item.consentChecks || []).length > 0 && consentStatus != null) {
      const consentActive = item.consentChecks.some((check) => !!consentStatus?.[check]);
      if (!consentActive) return 'disabled';
    }
    return visibility?.[item.key] !== false ? 'active' : 'inactive';
  };

  // Vaste volgorde (geen drift-handling nodig — er is geen order key).
  static getOrderedStatusItems = (visibility, currentPractice, consentStatus) => {
    return ClientWidgets.statusItems.map((item) => ({
      ...item,
      state: ClientWidgets.getStatusItemState(item, visibility, currentPractice, consentStatus),
    }));
  };

  // ---------------------------------------------------------------------------
  // internal_comment widget
  // ---------------------------------------------------------------------------
  //
  // Interne praktijknotitie op de client, zonder settings. De opslag leeft op
  // users.extra_data.internal_comments[<practice_id>] (html), per praktijk
  // gescheiden — de gating volgt uit de sleutel, geen aparte filter. De
  // runtime heeft drie modi: readonly (default), editing (advanced Editor +
  // save/cancel) en hidden (show-knop). Hide/show is puur lokale UI-state,
  // wordt nergens gepersisteerd.

  static internalCommentValueKey = 'internal_comment';

  // De notitie van de actieve praktijk uit de extra_data-blob (lege string
  // wanneer onbestaand of leeg).
  static getInternalComment = (extraData, practiceId) => {
    return ((extraData?.internal_comments || {})[String(practiceId)] || '');
  };
}
